import { render, staticRenderFns } from "./ConsultantQuestionnaire.vue?vue&type=template&id=00af3825"
import script from "./ConsultantQuestionnaire.vue?vue&type=script&lang=ts"
export * from "./ConsultantQuestionnaire.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports